
import { Interpolate, translate } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import * as React from "react";

import { Button, TooltipBody } from "@wg/wows-react-uikit";

import { Tooltip } from "components";

import { clanIsFull } from "../../../helpers/clan";
import { isoToFormattedLocalDate, isoToFormattedLocalTime } from "../../../helpers/datetime";
import { x } from "../../../helpers/localization";

export type IClan = {
  id: number;
  tag: string;
  name: string;
  color: string;
  active_applications: Array<any>; //FIXME
  active_invites: Array<any>; //FIXME
  members_count: number;
};

export type IProps = {
  currentAccount: {
    inClanCooldownTill: string;
  };
  clan: IClan;
  isEllipsis: boolean;
  onAcceptInvite: (arg0: {
    id: string;
    clan: IClan;
  }) => void;
  onSendApplication: (clan: IClan) => void;
  t: (s: string) => string;
};

class ButtonJoinClan extends React.PureComponent<IProps> {


  render() {
    const {
      t,
      currentAccount
    } = this.props;

    const isAlreadySentApplication = !isEmpty(this.props.clan.active_applications);
    const activeInviteId = !isEmpty(this.props.clan.active_invites) && this.props.clan.active_invites[0].id;
    const isFullClan = clanIsFull(this.props.clan);

    let isDisabled = false;
    let tooltipContent = null;
    let joinClanButtonLabel = t('Вступить в клан');
    let onClick = () => {
      this.props.onSendApplication(this.props.clan);
    };

    if (isAlreadySentApplication) {
      joinClanButtonLabel = t('Заявка отправлена');
      isDisabled = true;
    } else if (activeInviteId && isFullClan) {
      tooltipContent = <TooltipBody>
                    {t('Вам отправлено приглашение, но в клане сейчас нет мест.')}
                </TooltipBody>;
      isDisabled = true;
    } else if (currentAccount.inClanCooldownTill) {
      const i18nKey = activeInviteId ? x('Вы недавно покинули клан. Вы сможете вступить в клан начиная с %(date)s&nbsp;%(time)s.') : x('Вы недавно покинули клан. Вы сможете подать заявку в клан начиная с %(date)s&nbsp;%(time)s.');

      tooltipContent = <TooltipBody>
                    <Interpolate useDangerouslySetInnerHTML={true} i18nKey={i18nKey} date={isoToFormattedLocalDate(currentAccount.inClanCooldownTill)} time={isoToFormattedLocalTime(currentAccount.inClanCooldownTill)} parent={'p'} t={t} />
                </TooltipBody>;
      isDisabled = true;
    } else if (activeInviteId) {
      onClick = () => {
        this.props.onAcceptInvite({
          id: activeInviteId,
          clan: this.props.clan
        });
      };
    }

    return <Button onClick={onClick.bind(this)} isDisabled={isDisabled} tooltipContent={tooltipContent} tooltipComponent={Tooltip} tooltipBodyComponent={TooltipBody} isEllipsis={this.props.isEllipsis} isJustified>
                {joinClanButtonLabel}
            </Button>;
  }
}

export default translate()(ButtonJoinClan);